module.exports = "::ng-deep.reverse-component .icon-button.mat-raised-button {\n  margin: 0px!important;\n}\n"